import React from "react";

const WHATSAPP_HREF =
    "https://wa.me/84941524303?text=Bonjour%20Panther%2C%20je%20viens%20de%20consulter%20votre%20page%20d%27informations%20et%20j%27aimerais%20en%20savoir%20plus%20sur%20les%20tarifs%20et%20la%20personnalisation%20pour%20mon%20projet.";

export const WHATSAPP_URL = WHATSAPP_HREF;

function Icon({ size = 18 }) {
    return (
        <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
            <path d="M19.05 4.91A10 10 0 0 0 12 2C6.48 2 2 6.48 2 12c0 1.76.46 3.45 1.32 4.95L2 22l5.25-1.38A9.94 9.94 0 0 0 12 22c5.52 0 10-4.48 10-10 0-2.67-1.04-5.18-2.95-7.09zM12 20.27a8.2 8.2 0 0 1-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.27 8.27 0 1 1 7 3.86zm4.52-6.16c-.25-.12-1.47-.72-1.69-.8-.23-.08-.39-.12-.56.12-.16.25-.64.8-.78.97-.14.16-.29.18-.53.06-.25-.12-1.04-.38-1.99-1.22-.74-.66-1.23-1.47-1.37-1.72-.14-.25-.02-.39.11-.51.11-.11.25-.29.38-.43.12-.14.16-.25.25-.41.08-.16.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.49-.41-.42-.56-.43-.14-.01-.31-.01-.48-.01-.16 0-.43.06-.66.31-.23.25-.86.84-.86 2.05s.88 2.38 1 2.55c.12.16 1.74 2.65 4.21 3.71.59.25 1.05.4 1.41.51.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.1-.23-.16-.48-.28z" />
        </svg>
    );
}

/** Inline green WhatsApp CTA (useful inside cards). */
export function WhatsAppButton({ label = "Contact WhatsApp", className = "", testid = "whatsapp-cta" }) {
    return (
        <a
            href={WHATSAPP_HREF}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={testid}
            className={[
                "inline-flex items-center gap-2 px-4 py-2 bg-[#25D366] hover:bg-[#1ebe5b] text-black text-xs uppercase tracking-widest font-bold transition-colors",
                className,
            ].join(" ")}
        >
            <Icon /> {label}
        </a>
    );
}

/** Floating circular WhatsApp button (bottom-right). */
export function WhatsAppFloating({ testid = "whatsapp-floating" }) {
    return (
        <a
            href={WHATSAPP_HREF}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={testid}
            aria-label="Aide WhatsApp"
            className="fixed bottom-20 right-6 z-40 w-14 h-14 bg-[#25D366] hover:bg-[#1ebe5b] text-black flex items-center justify-center shadow-2xl shadow-black/50 transition-transform hover:scale-105"
        >
            <Icon size={28} />
        </a>
    );
}
